import { useState } from "react";
import { toast } from "sonner";
import { Coins, X, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useWalkie, notify } from "./WalkieLayout";

export default function TipDialog({ to, channelId, onClose }) {
  const { me, reloadMe } = useWalkie();
  const [amount, setAmount] = useState(10);
  const [busy, setBusy] = useState(false);
  const [txId] = useState(() => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post("/walkie/tip", { to_user_id: to.user_id, coins: Number(amount), channel_id: channelId, client_tx_id: txId });
      if (!r.data.duplicate) toast.success(`Tipped ${to.display_name} ${amount} coins`);
      reloadMe(); onClose();
    } catch (e) { notify.err(e); }
    setBusy(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center p-4" onClick={onClose} data-testid="walkie-tip-dialog">
      <div className="wt-root wt-card rounded-3xl p-5 w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <div className="font-black text-lg flex items-center gap-2"><Coins className="w-5 h-5 text-[#FFE300]" /> Tip {to.display_name}</div>
          <button onClick={onClose} aria-label="Close"><X className="w-5 h-5" /></button>
        </div>
        <div className="text-xs wt-muted mt-1">Your balance: {me.coins} coins</div>
        <div className="grid grid-cols-4 gap-2 mt-4">
          {[5, 10, 50, 100].map((v) => (
            <button key={v} onClick={() => setAmount(v)} data-testid={`walkie-tip-preset-${v}`}
              className={`py-2 rounded-xl font-black text-sm border ${Number(amount) === v ? "border-[#FFE300] bg-[#FFE300]/15 text-[#FFE300]" : "wt-line"}`}>{v}</button>
          ))}
        </div>
        <input type="number" min={1} value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="walkie-tip-amount"
          className="wt-input w-full mt-3 rounded-xl px-3 py-2 outline-none" />
        <button onClick={send} disabled={busy || !(Number(amount) > 0)} data-testid="walkie-tip-send"
          className="w-full mt-4 py-3 rounded-full bg-[#FFE300] text-black font-black flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send {amount} coins
        </button>
      </div>
    </div>
  );
}
